import AttachedFileService from '@/api/AttachedFileService';

const state = {
  selectedAttachedFile: null,
  selectedAttachedFiles: null,
};

const getters = {};

const actions = {
  resetAttachedFile({ commit }) {
    commit('selectedAttachedFile', null);
  },
  resetAttachedFiles({ commit }) {
    commit('selectedAttachedFiles', null);
  },
  attachedFile({ commit }, id) {
    return AttachedFileService.getAttachedFile(id).then((response) => {
      commit('selectedAttachedFile', response.data);
    });
  },
  attachedFiles({ commit }, ids) {
    return AttachedFileService.getAttachedFiles(ids).then((response) => {
      commit('selectedAttachedFiles', response.data);
    });
  },
};

const mutations = {
  selectedAttachedFile(state, payload) {
    state.selectedAttachedFile = payload;
  },
  selectedAttachedFiles(state, payload) {
    state.selectedAttachedFiles = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
